import script from "./patientDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./patientDetails.vue?vue&type=script&setup=true&lang=js"

import "./patientDetails.vue?vue&type=style&index=0&id=7282a496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7282a496"]])

export default __exports__